import _ from "lodash";

export function getDefaultItems (matching)
{
	const itemsDesire = _.filter(matching.items, item => item.listItemBar === 'desire');
	const itemsExperience = _.filter(matching.items, item => item.listItemBar === 'experience');

	return [
		{
			id: 'pre-filter',
			label: 'Match Wunsch',
			score: _.sumBy(itemsDesire, 'score'),
			maxScore: _.sumBy(itemsDesire, 'maxScore'),
			infoText: 'Übereinstimmung mit den von dir eingegebenen Wünschen.'
		},
		{
			id: 'total',
			label: 'Match Erfahrung',
			score: _.sumBy(itemsExperience, 'score'),
			maxScore: _.sumBy(itemsExperience, 'maxScore'),
			infoText: 'Übereinstimmung mit den von dir eingegebenen Erfahrungen und Ausbildungen.'
		},
	];
}
